import React from 'react';
import useReveal from '../hooks/useReveal';
import { useSiteMedia } from '../utils/useSiteMedia';

/**
 * SignatureHero — sits directly under the video hero on the homepage.
 *
 * Renders the brand's "two materials, one philosophy" thesis statement. The
 * accompanying image is admin-uploadable via the `home_signature` site_media
 * slot. If no image is configured the section just shows the heading +
 * subheading, no broken artwork.
 */
const SignatureHero = () => {
  const [ref, visible] = useReveal();
  const cfg = useSiteMedia('home_signature');
  const firstImage = (cfg?.media || []).find((m) => m?.url && (m?.kind === 'image' || !m?.kind));

  return (
    <section className="bg-[#F5EDDD] pt-12 md:pt-16 pb-2" data-testid="signature-hero">
      <div ref={ref} className={`reveal ${visible ? 'in' : ''} max-w-[1440px] mx-auto px-6 lg:px-10`}>
        <div className="text-center mb-8 max-w-3xl mx-auto">
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#A07A4F] mb-3">— Two materials, one philosophy</p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl text-[#33200F] leading-[1.05] mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Where timber meets <span className="italic text-[#5B3A24]">thread.</span>
          </h2>
          <p className="text-[#5B3A24] text-[15px] md:text-[16px] leading-[1.75]">
            Solid Australian hardwood on one side. Hand-upholstered bouclé on the other. Each piece carries the same idea — material first, ornament second, made to outlast trends.
          </p>
        </div>
        {firstImage && (
          <div className="relative overflow-hidden bg-[#EDE3CF]">
            <img
              src={firstImage.url}
              alt={firstImage.alt || 'Timber & Thread Co. signature composition'}
              className="w-full h-auto block image-zoom"
              loading="lazy"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default SignatureHero;
